import type { RegisterType } from '@shared/types/model'
import type { UserActivationType } from "@/shared/types";

export enum PageType {
  LANDING = 'landing',
  PAYMENT = 'payment',
  PAYMENT_SUCCESS = 'paymentSuccess',
  PAYWALL = 'paywall',
  RESULT = 'result',
  REGISTER = 'register',
  REGISTEROTP = 'registerOtp',
  QUIZ = 'quiz'
}

export type PageResponse = {
  meta: {
    requestId: string;
    httpStatus: number;
    message?: string;
    errorCode?: string;
  };
  result: {
    maintenance: boolean;
    siteFavicon: string | null;
    appName: string | null;
    appLogo: string | null;
    redirectTo?: string | null;
    bypassRegister?: boolean;
    subscriberId?: string;
    registerType?: RegisterType;
    allowSubscriberIdEditingOnRegisterPayment?: boolean;
    phoneNumberAllowedCountries?: string[];
    countryCode?: string;
    registerOnPayment?: boolean;
    registerOtpStatus?: boolean;
    hideGenerateFooter?: boolean;
    applicationLinks?: {
      genericDownloadUrl?: string;
      appStoreUrl?: string;
      googlePlayStoreUrl?: string;
      amazonStoreUrl?: string;
      microsoftStoreUrl?: string;
      huaweiAppGalleryUrl?: string;
      customerSupportUrl?: string;
      privacyUrl?: string;
      termsOfServiceUrl?: string;
      deeplinkAndroid?: string;
      deeplinkIos?: string;
      deeplinkWeb?: string;
    };
    deeplinkSettings: {
      deeplinkIosStatus: boolean;
      deeplinkAndroidStatus: boolean;
      deeplinkWebStatus: boolean;
    };
    social?: {
      googleLogin: boolean;
      facebookLogin: boolean;
      appleLogin: boolean;
    };
    pageOrder: string[];
    preview: boolean;
    sandbox: boolean;
    isStoreFlow: boolean;
    storeHash: string;
    gtmData: { isActive: 0 | 1; gtmCode: string };
    googleAdsData: {
      isActive: 0 | 1;
      gTag: string;
      conversionId: string;
      conversionLabel: string
    };
    gaData: {
      isActive: 0 | 1;
      gaCode: string;
    };
    facebookData: {
      isActive: 0 | 1;
      pixelId: string;
      integrationType: 'pixel' | 'capi' | 'both';
    };
    languageData: {
      language: string;
      isRightAlignment: boolean;
    };
    flowPage: {
      id: number;
      appId: number;
      teamId: number;
      flowId: number;
      templateId: number;
      pollId: number;
      title: string;
      order: number;
      status: 1 | 0;
      completionStatus: string;
      createDate: string;
      updateDate: string;
      themeId: null;
      page: string;
      template: {
        id: number;
        name: string;
        title: string;
        batch: string;
        defaultOrder: number;
        status: 1 | 0;
        isMandatory: 1 | 0;
        isStatusChangeable: 1 | 0;
        createDate: string;
        updateDate: string;
      };
      flow: {
        id: number;
        appId: number;
        teamId: number;
        name: string;
        previewHash: null | string;
        status: string;
        rejectionCount: number;
        createDate: string;
        updateDate: string;
        settings: string | null;
      };
      locales: Record<string, {
        id: number;
        appId: number;
        flowId: number;
        flowPageId: number;
        language: string;
        locale: string;
        name: string;
      }>;
    };
    providers: {
      stripe: boolean;
      creditCard: boolean;
      paypal: boolean;
      applePay: boolean;
      googlePay: boolean;
    };
    isPolicyRequired?: boolean;
    isZipcodeRequired?: boolean;
    epinDetails?: {
      packageId?: number,
      usage?: {
        language: string;
        content: string;
      }[],
      epinCodeAvailable?: boolean,
      epinCode?: string
    };
    websiteRedirectionSettings?: {
      status: 0 | 1;
      successPageUrl: string;
      warningPageUrl: string;
    };
    userActivationData?: {
      userActivation: UserActivationType;
      instruction: string;
    },
    restrictedCountries?: string[];
  };
};

export type LocalizationResponse = {
  meta: {
    requestId: string;
    httpStatus: number;
    message?: string;
  };
  result: Record<string, any>;
};

export type FetchImagesResponse = {
  meta: PageResponse['meta'];
  result: string[];
};
